// Shared visible copy for /why-us and its static HTML fallback.
// Keep this module import-free so the build prerender can read it.

export const WHY_US_PRINCIPLES = [
  [
    "Built around your work",
    "We start with your services, hours, pricing, and booking rules. The call flow should fit the business rather than make your team work around it.",
  ],
  [
    "Connected from the start",
    "The Front Office Bundle brings call answering, chat, CRM, and booking together. Each interaction has somewhere useful to go.",
  ],
  [
    "Tested before it represents you",
    "The team runs test calls and reviews the flow before launch. Ambiguous requests should have a defined handoff to a person.",
  ],
  [
    "Clear choices, plainly stated",
    "Published software plans start with an inquiry to confirm availability and setup. Custom websites, SEO, and integrations are scoped separately.",
  ],
  [
    "Your records remain yours",
    "Transcripts, recordings, and booking records are visible in your account and exportable. Your team can review how the system is working.",
  ],
] as const;

export const WHY_US_BUYER_QUESTIONS = [
  [
    "What should it handle?",
    "Start with the actual calls: routine questions, new inquiries, booking requests, and the situations that need a person.",
  ],
  [
    "What does it connect to?",
    "Bring your phone setup, calendar, CRM, and website. We confirm compatibility and scope before defining the integration.",
  ],
  [
    "What will the full cost be?",
    "Compare the subscription, usage, setup scope, and any custom work. The published Chleb plans show software prices; voice and SMS usage are separate.",
  ],
  [
    "Who keeps it useful?",
    "Decide who reviews records, updates business information, and raises a call-flow issue. Clear ownership matters after launch too.",
  ],
] as const;
